import React from "react";
import "../../App.css";
import { StyleSkills } from "./Body.styled/Skills.styled";
import { FaFigma, FaReact, FaSass, FaNodeJs } from "react-icons/fa";
import {
  SiAdobexd,
  SiAdobeillustrator,
  SiThreedotjs,
  SiMongodb,
  SiStrapi,
  SiTailwindcss,
  SiNpm,
  SiAdobephotoshop,
  SiApollographql,
  SiGraphql,
  SiCsharp,
  SiUnity,
  SiFlutter,
} from "react-icons/si";
import { FiFramer } from "react-icons/fi";
import { RiReactjsLine } from "react-icons/ri";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { motion } from "framer-motion";
import { skillTypeLTR, skillTypeRTL } from "./Animate/Skills.Animate";

function Skills() {
  return (
    <StyleSkills id="skills">
      <div className="Skills">
        <div className="skillsHeader">
          <div> MY Skills...</div>
          {/* {"      "}
          <FaBrain /> */}
        </div>
        <ul>
          <li>
            <motion.div
              className="skillType Frontend"
              initial="initial"
              // animate="animate"
              whileInView="whileinview"
              // transition= "transition"
              variants={skillTypeRTL}
            >
              Frontend Web Developer
            </motion.div>

            <div className="skills">
              <Splide
                aria-label="FrontEnd Skills"
                options={{
                  type: "loop",
                  drag: "free",
                  arrows: false,
                  pagination: false,
                  perPage: 4,
                  direction: "rtl",
                  autoScroll: {
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    rewind: false,
                    speed: 4,
                  },
                  breakpoints: {
                    767: {
                      perPage: 3,
                    },
                    600: {
                      perPage: 2,
                    },
                  },
                }}
                extensions={{ AutoScroll }}
              >
                <SplideSlide>
                  <div className="skillContainer">
                    <div className="frIcon framer-Icon">
                      <FiFramer />
                    </div>
                    <div>FramerMotion</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="frIcon react-Icon">
                      <FaReact />
                    </div>
                    <div>ReactJs</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="frIcon sass-Icon">
                      <FaSass />
                    </div>
                    <div>Sass</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="frIcon tailwind-Icon">
                      <SiTailwindcss />
                    </div>
                    <div>TailWindCss</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="frIcon strapi-Icon">
                      <SiStrapi />
                    </div>
                    <div>Strapi CMS</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="frIcon three-Icon">
                      <SiThreedotjs />
                    </div>
                    <div>ThreeJs</div>
                  </div>
                </SplideSlide>
              </Splide>
            </div>
          </li>

          <li>
            <motion.div
              className="skillType Backend"
              initial="initial"
              whileInView="whileinview"
              variants={skillTypeLTR}
            >
              Backend Developer
            </motion.div>

            <div className="skills">
              <Splide
                options={{
                  type: "loop",
                  drag: "free",
                  arrows: false,
                  pagination: false,
                  perPage: 4,
                  autoScroll: {
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    rewind: false,
                    speed: 4,
                  },
                  breakpoints: {
                    767: {
                      perPage: 3,
                    },
                    600: {
                      perPage: 2,
                    },
                  },
                }}
                extensions={{ AutoScroll }}
              >
                <SplideSlide>
                  <div className="skillContainer">
                    <div className="brIcon node-Icon">
                      <FaNodeJs />
                    </div>
                    <div>Nodejs</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="brIcon react-Icon">
                      <SiMongodb />
                    </div>
                    <div>MongoDb</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="brIcon npm-Icon">
                      <SiNpm />
                    </div>
                    <div>NPM</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="brIcon npm-Icon">
                      <SiApollographql />
                    </div>
                    <div>Apollo</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="brIcon npm-Icon">
                      <SiGraphql />
                    </div>
                    <div>GraphQL</div>
                  </div>
                </SplideSlide>
              </Splide>
            </div>
          </li>

          <li>
            <motion.div
              className="skillType UserInterface"
              initial="initial"
              whileInView="whileinview"
              variants={skillTypeRTL}
            >
              User Interface Design
            </motion.div>

            <div className="skills">
              <Splide
                options={{
                  type: "loop",
                  drag: "free",
                  arrows: false,
                  pagination: false,
                  perPage: 4,
                  direction: "rtl",
                  autoScroll: {
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    rewind: false,
                    speed: 4,
                  },
                  breakpoints: {
                    767: {
                      perPage: 3,
                    },
                    600: {
                      perPage: 2,
                    },
                  },
                }}
                extensions={{ AutoScroll }}
              >
                <SplideSlide>
                  <div className="skillContainer">
                    <div className="brIcon figma-Icon">
                      <FaFigma />
                    </div>
                    <div>Figma</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="brIcon xd-Icon">
                      <SiAdobexd />
                    </div>
                    <div>Adobe Experience</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="brIcon illustrator-Icon">
                      <SiAdobeillustrator />
                    </div>
                    <div>Adobe Illustrator</div>
                  </div>
                </SplideSlide>
                <SplideSlide>
                  <div className="skillContainer">
                    <div className="brIcon photoshop-Icon">
                      <SiAdobephotoshop />
                    </div>
                    <div>PhotoShop</div>
                  </div>
                </SplideSlide>
              </Splide>
            </div>
          </li>

          <li>
            <motion.div
              className="skillType otherTechnologies"
              initial="initial"
              whileInView="whileinview"
              variants={skillTypeLTR}
            >
              Other Technologies of Interest
            </motion.div>

            <div className="skills">
              <Splide
                options={{
                  type: "loop",
                  drag: "free",
                  arrows: false,
                  pagination: false,
                  perPage: 4,
                  autoScroll: {
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    rewind: false,
                    speed: 4,
                  },
                  breakpoints: {
                    767: {
                      perPage: 3,
                    },
                    600: {
                      perPage: 2,
                    },
                  },
                }}
                extensions={{ AutoScroll }}
              >
                <SplideSlide>
                  <div className="skillContainer">
                    <div className="techIcon cSharp-Icon">
                      <SiCsharp />
                    </div>
                    <div>C#</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="techIcon unity-Icon">
                      <SiUnity />
                    </div>
                    <div>Unity</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="techIcon flutter-Icon">
                      <SiFlutter />
                    </div>
                    <div>Flutter</div>
                  </div>
                </SplideSlide>

                <SplideSlide>
                  <div className="skillContainer">
                    <div className="techIcon reactNative-Icon">
                      <RiReactjsLine />
                    </div>
                    <div>React Native</div>
                  </div>
                </SplideSlide>
              </Splide>
            </div>
          </li>
        </ul>
      </div>
    </StyleSkills>
  );
}
// so i am thinking of adding a head image to the myskills
//age just to lighten up the place a lilbit
export default Skills;
